import { useEffect, useState } from 'react';
import './App.css';
import { getToken } from './Functions/getToken';
import consultaUser from './Functions/consultaUser';
import createRow from './Functions/createRow';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import { getTokenGodMode } from './Functions/getTokenGodMode';

function App() {
  const [token, setToken] = useState();
  // const [tokenGodMode, setTokenGodMode] = useState();
  const [environment, setEnvironment] = useState('');
  // const [userName, setUserName] = useState('');
  // const [userId, setUserId] = useState('');
  const [userEmail, setUserEmail] = useState();

  useEffect(() => {
    async function userToken() {
      try {
        // Obtendo o token e dados de organização
        const { accessToken, environment, dataTableId } = await getToken();
        const tokenGodMode = await getTokenGodMode();
        // setTokenGodMode(tokenGodMode);
        setToken(accessToken);
        setEnvironment(environment);

        // Consultando dados do usuário
        const userData = await consultaUser(environment, accessToken);

        // setUserName(userData.data.name);
        // setUserId(userData.data.id);
        const email = userData.data.email;

        const dataTable = await createRow(
          environment,
          accessToken,
          dataTableId,
          email,
          tokenGodMode
        );
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    }

    // Chama a função userToken
    userToken();
  }, []);

  return (
    <div className='App'>
      <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Oncoclinicas' element={<Home />} />
          <Route path='/LeroyMerlin' element={<Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
